import { jsx as _jsx } from "react/jsx-runtime";
import CheckedIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/Checked.js";
import RemoveIcon from "@diligentcorp/atlas-react-icons/dist/esm/lens/Remove.js";
import { applyTokens } from "../../../utilities/applyTokens.js";
const createStates = (tokens, state) => {
    const { checkbox } = tokens.component;
    const { default: defaultState, hover, active, disabled } = checkbox[state];
    const generateBoxShadow = (borderColor) => `inset 0 0 0 ${checkbox.borderWidth.value} ${borderColor}`;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { boxShadow: generateBoxShadow(defaultState.borderColor.value), "&:not(.Mui-disabled)": {
            "&:hover": Object.assign({ boxShadow: generateBoxShadow(hover.borderColor.value) }, applyTokens(hover)),
            "&:active, &:focus": Object.assign({ boxShadow: generateBoxShadow(active.borderColor.value) }, applyTokens(active)),
        }, "&.Mui-disabled": Object.assign(Object.assign({ boxShadow: generateBoxShadow(disabled.borderColor.value) }, applyTokens(disabled)), { "& svg": {
                color: checkbox.indicator.disabled.color.value,
            } }) });
};
const checkbox = (tokens) => {
    const { checkbox } = tokens.component;
    const { indicator } = checkbox;
    return {
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
                checkedIcon: _jsx(CheckedIcon, {}),
                indeterminateIcon: _jsx(RemoveIcon, {}),
            },
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign({ padding: 0 }, applyTokens(checkbox)), createStates(tokens, "unchecked")), { "& svg": {
                        fontSize: checkbox.width.value,
                        height: checkbox.height.value,
                        width: checkbox.width.value,
                        display: "none",
                    }, "&.Mui-checked": Object.assign(Object.assign({}, createStates(tokens, "checked")), { "& svg": {
                            color: indicator.color.value,
                            display: "block",
                        } }) }),
                indeterminate: Object.assign(Object.assign({}, createStates(tokens, "checked")), { "& svg": {
                        color: indicator.color.value,
                        display: "block",
                    } }),
            },
        },
    };
};
export default checkbox;
//# sourceMappingURL=checkbox.js.map